// Platform Settings API
import api, { type AxiosResponse } from './client';
import type {
  PlatformSettings,
  PlatformSettingsUpdate,
  PublicBranding,
  CountryDetectionResponse,
  MergeCompaniesResponse,
  DateAdjustmentResponse,
  DateAdjustmentLog,
} from './types';

export const platformSettingsAPI = {
  // Get platform settings (requires auth)
  getSettings: (): Promise<AxiosResponse<PlatformSettings>> =>
    api.get('/core/settings/platform/'),

  // Update platform settings
  updateSettings: (data: PlatformSettingsUpdate): Promise<AxiosResponse<{ message: string; data: PlatformSettings }>> =>
    api.put('/core/settings/platform/', data),

  // Partial update of platform settings
  patchSettings: (data: Partial<PlatformSettingsUpdate>): Promise<AxiosResponse<{ message: string; data: PlatformSettings }>> =>
    api.patch('/core/settings/platform/', data),

  // Get public branding (no auth required)
  getPublicBranding: (): Promise<AxiosResponse<PublicBranding>> =>
    api.get('/core/settings/branding/'),

  // Get platform display settings (any authenticated user — tab visibility, feature flags)
  getDisplaySettings: (): Promise<AxiosResponse<Pick<PlatformSettings, 'dashboard_tabs' | 'supplier_dashboard_tabs' | 'purchasing_tabs' | 'quality_tabs' | 'menu_visibility' | 'main_menu_type' | 'feature_flags' | 'supplier_card_fields' | 'data_import_tiles' | 'supplier_default_landing_path' | 'quality_measure_ppk'>>> =>
    api.get('/core/settings/display/'),

  // Detect country from IP (Feature 7)
  detectCountry: (): Promise<AxiosResponse<CountryDetectionResponse>> =>
    api.get('/core/settings/detect-country/'),

  // Merge companies (Feature 1)
  mergeCompanies: (targetId: number, sourceId: number): Promise<AxiosResponse<MergeCompaniesResponse>> =>
    api.post('/core/settings/merge-companies/', { target_id: targetId, source_id: sourceId }),

  // Adjust dates (Feature 6)
  adjustDates: (direction: 'plus' | 'minus'): Promise<AxiosResponse<DateAdjustmentResponse>> =>
    api.post('/core/settings/adjust-dates/', { direction }),

  // Get date adjustment logs (Feature 6)
  getDateAdjustmentLogs: (): Promise<AxiosResponse<DateAdjustmentLog[]>> =>
    api.get('/core/settings/date-adjustment-logs/'),
};
